import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  "./img/exterier/exterier-1.jpg",
  "./img/exterier/exterier-2.jpg",
  "./img/exterier/exterier-3.jpg",
  "./img/exterier/exterier-4.jpg",
  "./img/exterier/exterier-5.jpg",
  "./img/exterier/exterier-6.jpg",
  "./img/exterier/exterier-7.jpg",
  "./img/exterier/exterier-8.jpg",
  "./img/exterier/exterier-1.jpg",
];

const FotogalerieExterier: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Zahrada & exteriér | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie zahrady a exteriéru Hospůdky pod Rablinů."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLOVANÝ) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            ZAHRADA & EXTERIÉR
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Exteriér ${i + 1}`}
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieExterier;